import type { FC } from 'react';
import { useRouter } from 'next/navigation';
import { Button, IconSvg, Reorder } from '@/components';
import { TEMPLATE_BASE_PATH } from '@/constants';

import type { OrderDetailOrder } from './types';
import {
  OrderAddressSection,
  OrderItemsSection,
  OrderNotesSection,
  OrderPaymentSummary,
  OrderStatusTimeline,
} from './OrderDetails.component';
import styles from './orderdetail.module.scss';

type OrderDetailProps = {
  expandReorder?: boolean;
  order: OrderDetailOrder;
};

const OrderDetail: FC<OrderDetailProps> = ({ expandReorder = true, order }) => {
  const router = useRouter();
  const address = order?.delivery_address;
  const deliveryDetails = order?.delivery_details;

  return (
    <div className={styles.order}>
      <OrderStatusTimeline
        delivery={!!deliveryDetails?.delivery}
        status={order?.status}
      />

      <Reorder expandReorder={expandReorder} order={order} />

      <OrderItemsSection items={order?.line_items} />

      <OrderPaymentSummary deliveryDetails={deliveryDetails} order={order} />

      <OrderAddressSection
        address={address}
        deliveryDetails={deliveryDetails}
      />

      <OrderNotesSection notes={order?.notes} />

      <Button
        className={styles['order__continue-shopping-btn']}
        color="primary"
        onClick={() => router.push(TEMPLATE_BASE_PATH.SHOP)}
      >
        <div className={styles['order__continue-shopping-content']}>
          <span>Continue Shopping</span>
          <IconSvg name="arrow-right" />
        </div>
      </Button>
    </div>
  );
};

export default OrderDetail;
